import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");

// Prerendered pages ship full HTML in the source (great for SEO / link previews
// / view-source). We deliberately do a clean client render rather than hydrate:
// the pages fetch live data, so a true hydrate would mismatch and flicker. This
// way the crawler-visible HTML is correct AND the user always gets a correct,
// freshly-rendered layout. URLs and components are unchanged.
ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
